import {ToolbarPluginType} from '../../workbench-plugins/console/services/toolbar-plugin.interface';
import {LogMessage} from '../../workbench-plugins/console/services/log-message.interface';

export function getUrlParameterByName(name: string) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function isIE() {
    let ua = window.navigator.userAgent;
    return /MSIE|Trident/.test(ua);
}

export function getDataTestingIdForPluginType(t: ToolbarPluginType, prefix = '', suffix = ''): string {
    let out = prefix;
    switch (t) {
        case ToolbarPluginType.CLIPBOARD:
            out += 'clipboard';
            break;
        case ToolbarPluginType.GPS:
            out += 'location';
            break;
        case ToolbarPluginType.IMAGE_QUALITY:
            out += 'streaming-quality';
            break;
        case ToolbarPluginType.KEYBOARD_LAYOUT:
            out += 'keyboard-layout';
            break;
        case ToolbarPluginType.SPECIAL_KEYS:
            out += 'special-keys';
            break;
        case ToolbarPluginType.IOS_METRICS:
            out += 'gesture-metrics';
            break;
        case ToolbarPluginType.BIOMETRICS:
            out += 'biometrics';
            break;
        case ToolbarPluginType.CAMERA_SIMULATION:
            out += 'camera-sim';
            break;
        case ToolbarPluginType.GALLERY:
            out += 'gallery';
            break;
        case ToolbarPluginType.TEST:
            out += 'test';
            break;
        case ToolbarPluginType.TESTMAILS:
            out += 'testmails';
            break;
        case ToolbarPluginType.LOG:
            out += 'log';
            break;
        case ToolbarPluginType.DEBUGGING_VM:
            out += 'debugging';
            break;
        case ToolbarPluginType.DEVICE_SCREENSHOT:
            out += 'screenshot';
            break;
        case ToolbarPluginType.DEVICE_DETAILS:
            out += 'device-details';
            break;
        case ToolbarPluginType.SCREEN_READER:
            out += 'screen-reader';
            break;
        default:
            console.debug(`Unsupported plugin type ${t} for ID generation`, t);
            out += `${t}`;
    }
    if (suffix.length !== 0) {
        out += `${suffix}`;
    }
    return out;
}

export const normalizeLogMessage = (msg: LogMessage): LogMessage => ({
    ...msg,
    type: (msg.type ? msg.type : 'LOG'),
    timestamp: (msg.timestamp ? msg.timestamp : new Date().toLocaleTimeString())
});

export function b64EncodeUnicode(str: string) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode(('0x' + p1) as any);
    }));
}

export class ImagePool {
    constructor(private size: number, private images: Array<any> = [], private counter: number = 0) {
    }

    public next() {
        if (this.images.length < this.size) {
            const image = new Image();
            this.images.push(image);
            return image;
        } else {
            if (this.counter >= this.size) {
                // Reset for unlikely but theoretically possible overflow.
                this.counter = 0;
            }

            return this.images[this.counter++ % this.size];
        }
    }
}
